import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.y5y_1 = call;
        this.z5y_1 = data.z5m_1;
        this.a5z_1 = data.y5m_1;
        this.b5z_1 = data.b5n_1;
        this.c5z_1 = data.a5n_1;
        this.d5z_1 = data.d5n_1;
      }
      l5k() {
        return this.y5y_1;
      }
      dw() {
        return this.l5k().dw();
      }
      m5k() {
        return this.z5y_1;
      }
      n5k() {
        return this.a5z_1;
      }
      r2o() {
        return this.b5z_1;
      }
      y51() {
        return this.c5z_1;
      }
      f5k() {
        return this.d5z_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
